/*!
 *
 * utility.ts
 *
 */
const BREAKPOINTS = {
    phone: 768,
    tablet: 1024,
    desktop: 1280,
    largeDesktop: Infinity,
};
const getViewport = (ww) => {
    if (ww < BREAKPOINTS.phone) {
        return 'phone';
    }
    else if (ww < BREAKPOINTS.tablet) {
        return 'tablet';
    }
    else if (ww < BREAKPOINTS.desktop) {
        return 'desktop';
    }
    else {
        return 'largeDesktop';
    }
};
const getScrollbarWidth = () => {
    const element = document.createElement('div');
    element.style.visibility = 'hidden';
    element.style.overflow = 'scroll';
    document.body.appendChild(element);
    const scrollbarWidth = element.offsetWidth - element.clientWidth;
    document.body.removeChild(element);
    return scrollbarWidth;
};
const html = document.documentElement;
const setSize = () => {
    const vh = window.innerHeight * 0.01;
    html.style.setProperty('--vh', `${vh}px`);
    const scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
        html.style.setProperty('--scroll-bar', `${scrollbarWidth}px`);
    }
};
const handleResize = () => {
    const newViewport = getViewport(window.innerWidth);
    if (util.viewport !== newViewport) {
        util.viewport = newViewport;
        window.dispatchEvent(viewportChanged);
    }
    setSize();
};
const handleLoad = () => {
    setSize();
};
const initUtil = () => {
    const initialViewport = getViewport(window.innerWidth);
    const util = {
        ww: window.innerWidth,
        wh: window.innerHeight,
        hash: location.hash,
        viewport: initialViewport,
        scroller: 'html,body',
        isTouchDevice: 'ontouchstart' in window,
        reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    };
    if (util.isTouchDevice) {
        const body = document.body;
        body.setAttribute('ontouchstart', '');
    }
    return util;
};
const util = initUtil();
const viewportChanged = new CustomEvent('viewportChanged');
window.addEventListener('resize', handleResize, { passive: true });
document.readyState !== "loading" ? handleLoad() : document.addEventListener("DOMContentLoaded", handleLoad);
window.addEventListener('load', handleLoad, { passive: true });
export default util;
